const axios = require("axios");
const { axiosInstance } = require("./axiosManager");
const instructorUrl = process.env.REACT_APP_HOST_API + "/instructors"; 

export const getInstructorBySessionId = async (sessionId) => {
	if (!sessionId) return null;

	return axios
		.get(instructorUrl + "/session/" + sessionId)
		.then((response) => {
            return response.data.instructor
		})
		.catch((error) => {
			console.error(error);
		});
};
export const updateInstructor = async (instructor) => {
	if (!instructor) return null
	//console.log("setSessionInUser", userId, sessionId)
	let res = false
	// With the sign-in token: the server lets an instructor change only their own profile.
	await axiosInstance
		.put(instructorUrl + "/" + instructor.id, { instructor })
		.then((response) => {
			res = true
		})
		.catch((error) => {
			console.error(error)
		})
	return res
}
export const getInstructorById = async (id) => {
	if (!id) return null

	let res = null
	try {
		const response = await axios.get(instructorUrl + "/" + id)
		res = response.data.instructor
		return res
	} catch (error) {
		console.error(error)
		throw error
	}
}

export const getInstructorByUserId = async (userId) => {
	if (!userId) return null

	try {
		const response = await axios.get(instructorUrl + "/for-user/" + userId)
		return response.data.instructor
	} catch (error) {
		console.error(error)
		throw error
	}
}

// Role 1. A Cognito login puts the user-table id on currentUser. An older
// JWT login already puts the instructor primary key there.
// currentUser.kind (from /validate) names the table currentUser.id is in. An instructor with a
// user row - a Cognito sign-in, or a password account in the user table - reaches their
// instructor row through that user row; only an instructor-table sign-in has its id.
export const loadInstructorProfile = async (currentUser) => {
	if (!currentUser) return null
	if (currentUser.kind === 'instructor') return getInstructorById(currentUser.id)
	if (currentUser.uid || currentUser.kind === 'user') return getInstructorByUserId(currentUser.id)
	return getInstructorById(currentUser.id)
}